import React, { useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { I18nContext } from 'translations';

export default function EmptyForCompany() {
  const { translate } = useContext(I18nContext);

  return (
    <Grid container justify="center" alignItems="center" direction="column" data-testid="empty-for-company" style={{ padding: 40 }}>
      <img src="/images/booking/freight.svg" alt="empty" style={{ height: 120, marginBottom: 16 }} />
      <Typography variant="h6" color="textPrimary" align="center">
        {translate('app.deliveryRoute.emptyForCompany')}
      </Typography>
    </Grid>
  );
}
